import { takeEvery, put } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import * as api from 'data/api';
import { transformRequestReturnDetailsDto } from 'data/transformers/request-return-details';
import { transformShipmentItemDtos } from 'data/transformers/shipment-item';
import { transformReturnShippingOptionDtos } from 'data/transformers/return-shipping-option';
import { transformReturnCurrencyConversionDto } from 'data/transformers/return-currency-conversion';
import { transformReturnShipmentOrderDto } from 'data/transformers/return-shipment-order';
import { actions } from './slice';
export function* getRequestReturnDetailsDetails(_ref) {
  let {
    payload: {
      transactionId
    }
  } = _ref;
  const response = yield* call(api.getRequestReturnDetails, transactionId);

  if ('errors' in response) {
    var _response$errors, _response$errors$;

    yield put(actions.getReturnShipmentFailure({
      error: (response === null || response === void 0 ? void 0 : (_response$errors = response.errors) === null || _response$errors === void 0 ? void 0 : (_response$errors$ = _response$errors[0]) === null || _response$errors$ === void 0 ? void 0 : _response$errors$.value) || null
    }));
  } else {
    const returnShipment = transformRequestReturnDetailsDto(response.request_return_details);
    yield put(actions.getReturnShipmentSuccess(returnShipment));
  }
}
export function* getShipmentItems(_ref2) {
  let {
    payload: {
      transactionId
    }
  } = _ref2;
  const response = yield* call(api.getShipmentItems, transactionId);

  if ('errors' in response) {
    var _response$errors2, _response$errors2$;

    yield put(actions.getShipmentItemsFailure({
      error: (response === null || response === void 0 ? void 0 : (_response$errors2 = response.errors) === null || _response$errors2 === void 0 ? void 0 : (_response$errors2$ = _response$errors2[0]) === null || _response$errors2$ === void 0 ? void 0 : _response$errors2$.value) || null
    }));
  } else {
    const shipmentItems = transformShipmentItemDtos(response.items);
    yield put(actions.getShipmentItemsSuccess(shipmentItems));
  }
}
export function* getReturnShippingOptions(_ref3) {
  let {
    payload: {
      transactionId
    }
  } = _ref3;
  const response = yield* call(api.getReturnShippingOptions, transactionId);

  if ('errors' in response) {
    var _response$errors3, _response$errors3$;

    yield put(actions.getReturnShippingOptionsFailure({
      error: (response === null || response === void 0 ? void 0 : (_response$errors3 = response.errors) === null || _response$errors3 === void 0 ? void 0 : (_response$errors3$ = _response$errors3[0]) === null || _response$errors3$ === void 0 ? void 0 : _response$errors3$.value) || null
    }));
  } else {
    const returnShippingOptions = transformReturnShippingOptionDtos(response.return_shipping_options);
    const returnCurrencyConversion = response.currency_conversion && transformReturnCurrencyConversionDto(response.currency_conversion);
    yield put(actions.getReturnShippingOptionsSuccess({
      returnShipment: returnShippingOptions,
      currencyConversion: returnCurrencyConversion
    }));
  }
}
export function* createCustomReturnShipment(_ref4) {
  let {
    payload: {
      transactionId,
      returnShippingOption
    }
  } = _ref4;
  const response = yield* call(api.createCustomReturnShipment, {
    transactionId,
    returnShippingOption
  });

  if ('errors' in response) {
    var _response$errors4, _response$errors4$;

    yield put(actions.createCustomReturnShipmentFailure({
      error: (response === null || response === void 0 ? void 0 : (_response$errors4 = response.errors) === null || _response$errors4 === void 0 ? void 0 : (_response$errors4$ = _response$errors4[0]) === null || _response$errors4$ === void 0 ? void 0 : _response$errors4$.value) || null
    }));
  } else {
    yield put(actions.createCustomReturnShipmentSuccess());
  }
}
export function* prepareReturnLabelOrder(_ref5) {
  let {
    payload: {
      transactionId,
      pickupPointCode,
      packageTypeId,
      addressId
    }
  } = _ref5;
  const response = yield* call(api.prepareReturnLabelOrder, {
    transactionId,
    pickupPointCode,
    packageTypeId,
    addressId
  });

  if ('errors' in response) {
    var _response$errors5, _response$errors5$;

    yield put(actions.prepareReturnLabelOrderFailure({
      error: (response === null || response === void 0 ? void 0 : (_response$errors5 = response.errors) === null || _response$errors5 === void 0 ? void 0 : (_response$errors5$ = _response$errors5[0]) === null || _response$errors5$ === void 0 ? void 0 : _response$errors5$.value) || null
    }));
  } else {
    const returnShipmentOrder = transformReturnShipmentOrderDto(response.return_label_order);
    const currencyConversion = response.return_label_order.currency_conversion && transformReturnCurrencyConversionDto(response.return_label_order.currency_conversion);
    yield put(actions.prepareReturnLabelOrderSuccess({
      returnShipmentOrder,
      currencyConversion
    }));
  }
}
export function* getReturnLabelOrder(_ref6) {
  let {
    payload: {
      orderId
    }
  } = _ref6;
  const response = yield* call(api.getReturnLabelOrder, orderId);

  if ('errors' in response) {
    yield put(actions.getReturnLabelOrderFailure());
    return;
  }

  const returnShipmentOrder = transformReturnShipmentOrderDto(response.return_label_order);
  yield put(actions.getReturnLabelOrderSuccess({
    returnShipmentOrder
  }));
}
export default function* saga() {
  yield takeEvery(actions.getReturnShipmentRequest, getRequestReturnDetailsDetails);
  yield takeEvery(actions.getShipmentItemsRequest, getShipmentItems);
  yield takeEvery(actions.getReturnShippingOptionsRequest, getReturnShippingOptions);
  yield takeEvery(actions.createCustomReturnShipmentRequest, createCustomReturnShipment);
  yield takeEvery(actions.prepareReturnLabelOrderRequest, prepareReturnLabelOrder);
  yield takeEvery(actions.getReturnLabelOrderRequest, getReturnLabelOrder);
}